var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyStructure3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 112,
    viewBox: "0 0 97 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.7016 0H28.4025C16.6143 0 7.05811 9.54716 7.05811 21.3242V49.7368C7.05811 61.5138 16.6143 71.061 28.4025 71.061H68.7016C80.4897 71.061 90.046 61.5138 90.046 49.7368V21.3242C90.046 9.54716 80.4897 0 68.7016 0Z",
    fill: "#FE6571"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0152 69.3516H22.0895C10.3013 69.3516 0.745117 78.8954 0.745117 90.6684C0.745117 102.441 10.3013 111.985 22.0895 111.985H75.0152C86.8034 111.985 96.3596 102.441 96.3596 90.6684C96.3596 78.8954 86.8034 69.3516 75.0152 69.3516Z",
    fill: "#FE6571"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyStructure3);
export default __webpack_public_path__ + "static/media/body-structure3.fe1bfc2fe871b7c2152e83ae66663fd9.svg";
export { ForwardRef as ReactComponent };